import script from "./ConsolePlans.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsolePlans.vue?vue&type=script&setup=true&lang=js"

import "./ConsolePlans.vue?vue&type=style&index=0&id=0c60cc5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c60cc5a"]])

export default __exports__